import "./TextInput.css";
import moment from "moment";

export const TextInput = ({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  error,
  maskType, // "currency", "number", "date", phone, "none"
  type = "text",
}) => {
  const formatValue = (val) => {
    if (maskType === "currency") {
      const raw = val.replace(/\D/g, "");
      const numberValue = Number(raw) / 100;
      return numberValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
    if (maskType === "date") {
      return moment(val).format("YYYY-MM-DD")
    }
    if (maskType === "phone") {
      const digits = val.replace(/\D/g, "").slice(0, 13);
      const part1 = digits.slice(0, 2);
      const part2 = digits.slice(2, 4);
      const part3 = digits.slice(4, 5);
      const part4 = digits.slice(5, 9);
      const part5 = digits.slice(9, 13);
      let formatted = "+";
      if (part1) formatted += part1;
      if (part2) formatted += ` (${part2}`;
      if (part3) formatted += `) ${part3}`;
      if (part4) formatted += ` ${part4}`;
      if (part5) formatted += `-${part5}`;
      return formatted;
    }
    return val;
  };

  const handleChange = (e) => {
    const rawValue = e.target.value;
    const masked = formatValue(rawValue);
    onChange(masked);
  };

  return (
    <div className="textInputWrapperCompanies">
      {label && (
        <label className="textInputLabel" htmlFor={name}>{label}</label>
      )}
      <div className="textWrapper">
        <input
          type={maskType === "date" ? "date" : type}
          name={name}
          className="textInput"
          placeholder={placeholder}
          value={formatValue(value)}
          onChange={handleChange}
          inputMode={
            maskType === "currency" || maskType === "number" || maskType === "phone" || maskType === "date"
              ? "numeric"
              : "text"
          }
        />
        {error && <div className="textError">{error}</div>}
      </div>
    </div>
  );
};

export default TextInput;
